<template>
    <div>
        <div class="p-4">
            <h1 class="text-lg font-bold">{{displayName | capitalizeFirstLetter}} introuvable</h1>
            <sav-input
            type="text"
            class="my-3"
            placeholder="Où avez-vous acheté votre produit ?"
            rows="5"
            v-model="requestComment"
            />

            <button :disabled="loadingRequest" @click="sendRequestForm()" class="bg-green-500 hover:bg-green-600 text-sm text-white font-light p-2 px-3 rounded-xl duration-200">
                <span class="pl-1">
                    <i class="fa-solid fa-check mr-0.5"></i> {{ $tt('Envoyer') }}
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    props: {
        displayName: {
            type: String,
            required: true
        },
        libelle: {
            type: String,
            required: true
        },
        end: {
            required: true
        }
    },

    data() {
        return {
            requestComment: null,
            loadingRequest: false
        }
    },

    computed: {
        uniqueId() {
            let id = this.displayName.replace(' ', '-')
            return 'modal-request-' + id + '-' + Date.now()
        }
    },

    filters: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },

    methods: {
        async sendRequestForm() {
            this.loadingRequest = true
            let response = await apiService.post('no_mag', {
                comment: this.requestComment,
                libelle: this.libelle
            })
            if (response.data.posts.post) {
                this.$modal.hideAll()
                this.end({id: response.data.posts.post, label: this.requestComment, img: null, requested: true})
            }
            this.loadingRequest = false
        },
    }
}
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/processes/cards/warranty/ModalSignNotFound.vue